module.exports = __webpack_public_path__ + "img/line_graph.41d882e2.png";